import { render, staticRenderFns } from "./Reserve.vue?vue&type=template&id=6964fde6"
import script from "./Reserve.vue?vue&type=script&lang=js"
export * from "./Reserve.vue?vue&type=script&lang=js"
import style0 from "./Reserve.vue?vue&type=style&index=0&id=6964fde6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_ejs@3.1.10_vue-template-compiler@2.6.14_webpack@5.93.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports